import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import rebrandStyles from '@jobcase/react_pattern_library/styles/rebrand';
import Toaster from '@jobcase/react_pattern_library/components/Toaster/Toaster';
import { VARIANTS } from '@jobcase/react_pattern_library/components/Notification';
import CheckRebrandLightSVG from '@jobcase/react_pattern_library/components/SVGIcon/icons/CheckRebrandLightSVG';

import { clearNotification } from '../../redux/nodes/notification/actions';
import {
  getIsNotificationVisible,
  getNotificationVariant,
  getNotificationMessage,
  getNotificationStartIcon,
  getNotificationPersist,
} from '../../redux/nodes/notification/selectors';

import { useAppContext, useSelector } from '../../utils/hooks';
import { GLOBAL_TOASTER_NOTIFICATION_TIMEOUT } from '../../constants';

const ToasterNotificationWrapper = styled.div`
  bottom: 0;
  left: 50%;
  position: fixed;
  transform: translateX(-50%);
  width: 100%;
  z-index: 9001;

  @media(min-width: ${rebrandStyles.breakpoint.md}) {
    bottom: unset;
    left: unset;
    position: fixed;
    right: 38px;
    top: 100px;
    transform: translateX(0);
    width: calc(100vw - 240px - 64px);
  }

  [class*="Notification__CloseWrapper-sc"] {
    margin: 0 0 0 20px;

    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledToasterNotification = styled.div`
  height: fit-content;
  padding: 0 ${rebrandStyles.spacing.tiny}px ${rebrandStyles.spacing.tiny}px;
  width: 100%;

  svg {
    margin-top: ${rebrandStyles.spacing.extraExtraTiny}px;
  }

  @media(min-width: ${rebrandStyles.breakpoint.md}) {
    padding: unset;

    div {
      color: ${rebrandStyles.color.textGrayColor};
    }
  }
`;

const StyledNotification = styled(Toaster)`
  border-radius: ${rebrandStyles.spacing.borderRadius}px;
  padding: ${rebrandStyles.spacing.tiny}px;

  svg {
    height: 22px;
    width: 22px;
  }
`;

const GlobalToasterNotification = () => {
  const dispatch = useDispatch();
  const { isMobile } = useAppContext();
  const isVisible = useSelector(getIsNotificationVisible);
  const variant = useSelector(getNotificationVariant);
  const message = useSelector(getNotificationMessage);
  const startIcon = useSelector(getNotificationStartIcon);
  const persist = useSelector(getNotificationPersist);

  const handleToasterNotificationClose = () => {
    dispatch(clearNotification());
  };

  useEffect(() => {
    let timer = null;
    if (isVisible && !persist) {
      timer = setTimeout(handleToasterNotificationClose, GLOBAL_TOASTER_NOTIFICATION_TIMEOUT);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [isVisible, persist]);

  return (
    <>
      {isVisible && (
        <ToasterNotificationWrapper>
          <StyledToasterNotification>
            <StyledNotification
              hideCloseButton={false}
              isMobile={isMobile}
              onClose={handleToasterNotificationClose}
              text={message}
              variant={variant}
              startIcon={startIcon || CheckRebrandLightSVG}
              showStartIcon={variant !== VARIANTS.INFO}
            />
          </StyledToasterNotification>
        </ToasterNotificationWrapper>
      )}
    </>
  );
};

export default GlobalToasterNotification;
